/* ============================================================
   AS-CHATBOT — Moteur d'arbre de décision (Atelier Sauli)
   Vanilla JS, zéro dépendance. Lit l'arborescence JSON du snippet.
   Bascule "Parler à l'équipe" -> Shopify Inbox (live) avec repli email.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-as-chatbot]');
  if (!root) return;

  var treeEl = root.querySelector('[data-as-tree]');
  var DATA;
  try {
    DATA = JSON.parse(treeEl.textContent);
  } catch (e) {
    console.error('[as-chatbot] arborescence JSON invalide :', e);
    return;
  }

  var launcher = root.querySelector('[data-as-launcher]');
  var teaser = root.querySelector('[data-as-teaser]');
  var teaserClose = root.querySelector('[data-as-teaser-close]');
  var panel = root.querySelector('[data-as-panel]');
  var body = root.querySelector('[data-as-body]');
  var closeBtn = root.querySelector('[data-as-close]');
  var restartBtn = root.querySelector('[data-as-restart]');
  var fallbackEmail = root.getAttribute('data-inbox-fallback-email') || '';

  var started = false;
  var TYPING_MS = 480; // délai "en train d'écrire" entre deux messages

  /* ---------- Ouverture / fermeture ---------- */
  function openChat() {
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    hideTeaser();
    if (!started) {
      started = true;
      goTo(DATA.start);
    }
    panel.querySelector('.as-chatbot__min').focus();
  }
  function closeChat(keepLauncherFocus) {
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    // En cas de handoff vers Inbox, on garde le focus sur le composer d'Inbox.
    if (!keepLauncherFocus) launcher.focus();
  }
  function toggleChat() {
    if (root.classList.contains('is-open')) closeChat();
    else openChat();
  }

  /* ---------- Teaser ---------- */
  var teaserAutoHide;
  function showTeaser() {
    if (root.classList.contains('is-open')) return;
    if (sessionStorage.getItem('as-teaser-closed') === '1') return;
    teaser.hidden = false;
    teaser.classList.remove('is-closing');
    /* Reste quelques secondes puis se referme tout seul (une fois par session) */
    clearTimeout(teaserAutoHide);
    teaserAutoHide = setTimeout(function () {
      hideTeaserAnimated();
      sessionStorage.setItem('as-teaser-closed', '1');
    }, 6000);
  }
  function hideTeaser() { clearTimeout(teaserAutoHide); teaser.classList.remove('is-closing'); teaser.hidden = true; }
  function hideTeaserAnimated() {
    if (teaser.hidden) return;
    teaser.classList.add('is-closing');
    setTimeout(function () { teaser.hidden = true; teaser.classList.remove('is-closing'); }, 240);
  }

  /* ---------- Rendu des messages ---------- */
  function scrollDown() { body.scrollTop = body.scrollHeight; }

  function addMessage(text, who) {
    var el = document.createElement('div');
    el.className = 'as-chatbot__msg as-chatbot__msg--' + (who || 'bot');
    el.textContent = text;
    body.appendChild(el);
    scrollDown();
    return el;
  }

  function showTyping() {
    var el = document.createElement('div');
    el.className = 'as-chatbot__msg as-chatbot__msg--bot as-chatbot__typing-wrap';
    el.innerHTML = '<span class="as-chatbot__typing"><span></span><span></span><span></span></span>';
    body.appendChild(el);
    scrollDown();
    return el;
  }

  // Affiche une série de messages bot avec effet "typing", puis callback
  function streamMessages(messages, done) {
    var queue = messages.slice();
    function next() {
      if (!queue.length) { if (done) done(); return; }
      var typing = showTyping();
      setTimeout(function () {
        typing.remove();
        addMessage(queue.shift(), 'bot');
        next();
      }, TYPING_MS);
    }
    next();
  }

  /* ---------- Options (boutons) ---------- */
  function resolveOptions(opts) {
    if (opts === '@main') return DATA.mainCategories;
    return opts || [];
  }

  function renderOptions(options) {
    var wrap = document.createElement('div');
    wrap.className = 'as-chatbot__options';
    options.forEach(function (opt) {
      var btn;
      if (opt.url) {
        btn = document.createElement('a');
        btn.href = opt.url;
        btn.target = '_blank';
        btn.rel = 'noopener';
      } else {
        btn = document.createElement('button');
        btn.type = 'button';
      }
      btn.className = 'as-chatbot__opt' + (opt.ghost ? ' as-chatbot__opt--ghost' : '');
      btn.textContent = opt.label;
      btn.addEventListener('click', function () {
        if (opt.url) { hideOptions(wrap); return; } // lien : laisse le navigateur faire
        handleChoice(opt, wrap);
      });
      wrap.appendChild(btn);
    });
    body.appendChild(wrap);
    scrollDown();
    return wrap;
  }

  // Désactive un bloc d'options après un clic (évite les doubles parcours)
  function hideOptions(wrap) {
    Array.prototype.forEach.call(wrap.querySelectorAll('button, a'), function (b) {
      b.disabled = true;
      b.style.pointerEvents = 'none';
      b.style.opacity = '0.55';
    });
  }

  function handleChoice(opt, wrap) {
    if (wrap) hideOptions(wrap);
    addMessage(opt.label, 'user');
    if (opt.action === 'restart') { goTo(DATA.start); return; }
    if (opt.goto) { goTo(opt.goto); return; }
  }

  /* ---------- Écran de sortie ---------- */
  function renderEndScreen() {
    var opts = DATA.mainCategories.slice();
    opts.push({ label: DATA.endLabel || "J'ai terminé", goto: 'done-resolved', ghost: true });
    streamMessages(['Souhaites-tu autre chose ?'], function () {
      renderOptions(opts);
    });
  }

  /* ---------- Satisfaction ---------- */
  function renderFeedback() {
    var wrap = document.createElement('div');
    wrap.className = 'as-chatbot__rating';
    [
      { e: '😍', v: 'excellent' },
      { e: '🙂', v: 'bien' },
      { e: '😐', v: 'moyen' }
    ].forEach(function (r) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'as-chatbot__rate';
      b.textContent = r.e;
      b.setAttribute('aria-label', 'Noter : ' + r.v);
      b.addEventListener('click', function () {
        hideOptions(wrap);
        addMessage(r.e, 'user');
        // Hook analytics optionnel
        try {
          if (window.dataLayer) window.dataLayer.push({ event: 'chatbot_feedback', rating: r.v });
        } catch (e) {}
        goTo('thanks');
      });
      wrap.appendChild(b);
    });
    body.appendChild(wrap);
    scrollDown();
  }

  /* ---------- Navigation entre nœuds ---------- */
  function goTo(nodeId) {
    var node = DATA.nodes[nodeId];
    if (!node) { console.warn('[as-chatbot] nœud introuvable :', nodeId); return; }

    var messages = Array.isArray(node.msg) ? node.msg : [node.msg];

    streamMessages(messages, function () {
      if (node.options) {
        renderOptions(resolveOptions(node.options));
        if (node.after) streamMessages([node.after], null);
      } else if (node.feedback) {
        renderFeedback();
      } else if (node.end) {
        renderEndScreen();
      } else if (node.closing) {
        renderOptions([{ label: '↺ Recommencer', action: 'restart', ghost: true }]);
      }
    });
  }

  /* ---------- Reset ---------- */
  function restartConversation() {
    body.innerHTML = '';
    goTo(DATA.start);
  }

  /* ---------- Écouteurs ---------- */
  launcher.addEventListener('click', toggleChat);
  closeBtn.addEventListener('click', function () { closeChat(); });
  restartBtn.addEventListener('click', restartConversation);
  if (teaserClose) {
    teaserClose.addEventListener('click', function () {
      hideTeaser();
      sessionStorage.setItem('as-teaser-closed', '1');
    });
  }
  if (teaser) {
    teaser.addEventListener('click', function (e) {
      if (e.target === teaserClose) return;
      openChat();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeChat();
  });

  /* ---------- Init ---------- */
  setTimeout(showTeaser, 3500);
})();
